import { size } from "lib/theme/size";
import { SxObjType } from "lib/theme/types/SxObjType.type";
import theme from "lib/theme/theme";

const sxStyles = () => {
  return {
    requireText: {
      color: theme.palette.grey[400],
      fontSize: size.FONTSIZE_14,
    },
  } satisfies SxObjType;
};

export { sxStyles };
